import mutationsTypes from '@/vuex/ui/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_INFORMACAO: 'GET_INFORMACAO',
  CONFIRMAR: 'CONFIRMAR'
}

export default types
